/**
 * Generated by orval v6.26.0 🍺
 * Do not edit manually.
 * 爆版
 * OpenAPI spec version: 1.0.0
 */
import { axiosInstance } from "../../axiosInstance";
export type PostBaobPcComplaintRecordScore200Data = { [key: string]: any };

export type PostBaobPcComplaintRecordScore200 = {
  code: number;
  data: PostBaobPcComplaintRecordScore200Data;
  msg: string;
};

export type PostBaobPcComplaintRecordScoreBody = {
  /** 反馈记录ID */
  complaintId?: number;
  /** 商家评分 */
  score?: number;
  /** 商家id */
  supply_id?: number;
  /** 用户ID */
  user_id?: number;
  /** 用户名称 */
  user_name?: string;
};

export type PostBaobPcComplaintRecordDetail200 = {
  code: number;
  data: PostBaobPcComplaintRecordDetail200Data;
  msg: string;
};

export type PostBaobPcComplaintRecordDetail200DataDetailInfoItemVideoOrImgsItem =
  {
    imageUrl: string;
    videoUrl: string;
  };

export type PostBaobPcComplaintRecordDetail200DataDetailInfoItem = {
  classifyName?: string;
  content: string;
  createdAt: string;
  handleScore?: string;
  infoType: number;
  title: string;
  videoOrImgs: PostBaobPcComplaintRecordDetail200DataDetailInfoItemVideoOrImgsItem[];
};

export type PostBaobPcComplaintRecordDetail200Data = {
  complaintId: number;
  detailInfo: PostBaobPcComplaintRecordDetail200DataDetailInfoItem[];
  isPopupScore: number;
};

export type PostBaobPcComplaintRecordDetailBody = {
  /** 反馈记录ID */
  complaintId?: number;
  /** 商家id */
  supply_id?: number;
};

export type PostBaobPcComplaintRecordList200DataDataListItem = {
  classifyName: string;
  complaintId: number;
  content: string;
  createdAt: string;
  handleStatus: number;
};

export type PostBaobPcComplaintRecordList200Data = {
  dataList: PostBaobPcComplaintRecordList200DataDataListItem[];
  pages: number;
  total: number;
};

export type PostBaobPcComplaintRecordList200 = {
  code: number;
  data: PostBaobPcComplaintRecordList200Data;
  msg: string;
};

export type PostBaobPcComplaintRecordListBody = {
  /** 当前页码 */
  pageNumber?: number;
  /** 当前页码 */
  pageSize?: number;
  /** 用户角色ID */
  roleId?: number;
  /** 店铺ID */
  shopId?: number;
  /** 商家id */
  supply_id?: number;
};

export type PostBaobPcComplaintRecordSubmit200Data = {
  describe: string;
  icon: string;
  title: string;
};

export type PostBaobPcComplaintRecordSubmit200 = {
  code: number;
  data: PostBaobPcComplaintRecordSubmit200Data;
  msg: string;
};

export type PostBaobPcComplaintRecordSubmitBody = {
  /** 投诉分类子级ID */
  classifyId: string;
  /** 投诉内容 */
  content: string;
  /** 联系电话 */
  mobile: string;
  /** 用户角色ID */
  roleId?: number;
  /** 用户角色名称 */
  roleName?: string;
  /** 截图(多张截图英文逗号分割) */
  screenshot: string;
  /** 店铺ID */
  shopId?: number;
  /** 店铺名称 */
  shopName?: string;
  /** 供应商Id */
  supply_id?: string;
  /** 用户id */
  userId?: number;
  /** 用户名称 */
  userName?: string;
  /** 视频 */
  video?: string;
  /** 视频封面图片 */
  videoCoverImg?: string;
};

export type PostBaobPcComplaintClassifyList200DataItemChildrenItem = {
  label: string;
  parentId: number;
  sort: number;
  value: number;
};

export type PostBaobPcComplaintClassifyList200DataItem = {
  children: PostBaobPcComplaintClassifyList200DataItemChildrenItem[];
  label: string;
  parentId: number;
  sort: number;
  value: number;
};

export type PostBaobPcComplaintClassifyList200 = {
  code: number;
  data: PostBaobPcComplaintClassifyList200DataItem[];
  msg: string;
};

export type PostBaobPcComplaintClassifyListBody = {
  /** 商家id */
  supply_id?: number;
};

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary 获取投诉分类
 */
export const postBaobPcComplaintClassifyList = (
  postBaobPcComplaintClassifyListBody: PostBaobPcComplaintClassifyListBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcComplaintClassifyList200>(
    {
      url: `/baob/pc.complaint/classifyList`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: postBaobPcComplaintClassifyListBody,
    },
    options,
  );
};

/**
 * @summary 投诉反馈提交
 */
export const postBaobPcComplaintRecordSubmit = (
  postBaobPcComplaintRecordSubmitBody: PostBaobPcComplaintRecordSubmitBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcComplaintRecordSubmit200>(
    {
      url: `/baob/pc.complaint/recordSubmit`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: postBaobPcComplaintRecordSubmitBody,
    },
    options,
  );
};

/**
 * @summary 获取投诉反馈记录列表
 */
export const postBaobPcComplaintRecordList = (
  postBaobPcComplaintRecordListBody: PostBaobPcComplaintRecordListBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcComplaintRecordList200>(
    {
      url: `/baob/pc.complaint/recordList`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: postBaobPcComplaintRecordListBody,
    },
    options,
  );
};

/**
 * @summary 获取投诉反馈记录详情
 */
export const postBaobPcComplaintRecordDetail = (
  postBaobPcComplaintRecordDetailBody: PostBaobPcComplaintRecordDetailBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcComplaintRecordDetail200>(
    {
      url: `/baob/pc.complaint/recordDetail`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: postBaobPcComplaintRecordDetailBody,
    },
    options,
  );
};

/**
 * @summary 商家评分提交
 */
export const postBaobPcComplaintRecordScore = (
  postBaobPcComplaintRecordScoreBody: PostBaobPcComplaintRecordScoreBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcComplaintRecordScore200>(
    {
      url: `/baob/pc.complaint/recordScore`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: postBaobPcComplaintRecordScoreBody,
    },
    options,
  );
};

export type PostBaobPcComplaintClassifyListResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcComplaintClassifyList>>
>;
export type PostBaobPcComplaintRecordSubmitResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcComplaintRecordSubmit>>
>;
export type PostBaobPcComplaintRecordListResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcComplaintRecordList>>
>;
export type PostBaobPcComplaintRecordDetailResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcComplaintRecordDetail>>
>;
export type PostBaobPcComplaintRecordScoreResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcComplaintRecordScore>>
>;
